<transform-table [transformInstructions]="currentAgreementTransformations" [entity]="data"></transform-table>
